import React from "react";
import { Link, NavLink } from "react-router-dom";
import "../footer/footer.scss"


const Footer = () => {

    return (
        <footer className="footer">
            <div className="wrapper">
                <div className="container">
                    <div className="top">
                        <div className="left">
                            <b>Musikkapelle St. Lorenzen EO</b>
                            <p>
                                Franz Hellweger Platz 3A<br />
                                39030 St. Lorenzen<br />
                                Südtirol – Italien
                            </p>
                        </div>
                        <div className="right">
                            <Link className="lineLink" to="mailto:info@mk-lorenzen.it">info@mk-lorenzen.it</Link>
                            <Link className="lineLink" to="tel:+393889544759">+39 388 954 4759</Link>
                        </div>
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <span>© {new Date().getFullYear()} Musikkapelle St. Lorenzen EO</span>
                        </div>
                        <div className="right">
                            <NavLink to={`/impressum`} className="lineLink">Impressum</NavLink>
                            <NavLink to={`/datenschutz`} className="lineLink">Datenschutz</NavLink>
                            <NavLink to={`/kontakt`} className="lineLink">Kontakt</NavLink>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bottom">
                <div className="container">
                    <div className="left">
                        <Link to="https://www.stlorenzen.eu/" target="blank">
                            <img src="https://www.stlorenzen.eu/system/web/GetImage.ashx?fileid=938281&mode=T&width=200&height=200&ratio=true&fit=false&shadow=false&cts=1484824727" alt="Bruneck" />
                        </Link>
                        <Link to="https://vsm.bz.it/" target="blank">
                            <img src="/assets/vsm_logo.svg" alt="VSM" />
                        </Link>

                    </div>
                    <Link to="/kontakt#5promille" className="right">
                        <div className="top">
                            <h3>5‰</h3>
                            <span>für die</span>
                        </div>
                        <span>Musikkapelle St. Lorenzen</span>
                    </Link>
                </div>
            </div>
        </footer>
    )
};

export default Footer